export const CART = "Cart";

export const CART_ITEM_MESSAGE = "item in your cart";
export const CART_ITEM_MESSAGE_PLURAL = "items in your cart";

export const SUB_TOTAL = "Sub Total";

export const CHECKOUT = "Check Out";
export const LOGIN_SUCCESS = "Login Successful!";
